<template>
  <div class="monitor-container container-view" ref="pageView">
    <!-- title -->
    <section class="title-section">
      <p class="titleInfo fl">{{ curTime }}</p>
      <p class="titleText">广州市城市配送车辆监控看板</p>
      <div class="button-list">
        <el-button
          class="g-form-section-search operate__item"
          plain
          @click="handleRouterPush('/gdColdBoard')"
          >广州冷配监控看板</el-button
        >
        <el-button
          class="g-form-section-search operate__item"
          plain
          @click="handleRouterPush('/gdDryBoard')"
          >广州干货监控看板</el-button
        >
      </div>
    </section>
    <section class="main">
      <section class="chartPanel">
        <!--topLeft-->
        <div
          class="chartPanel-child topLeft"
          v-loading="topLeftLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel_title">
            <span>·</span>广州市配送企业和配送车辆数量情况
          </div>
          <div class="chartPanel-child-box">
            <div class="detail-item">
              <img class="train-umber" src="./images/01.png" alt="" />
              <div class="detail-info">
                <div class="info-item">
                  企业数量:
                  <span class="value">{{
                    detailInfo.totalCompanyQuantity
                  }}</span>
                </div>
                <div class="info-item">
                  冷链企业:
                  <span class="value">{{
                    detailInfo.refrigeratedCompanyQuantity
                  }}</span>
                </div>
                <div class="info-item">
                  干货企业:
                  <span class="value">{{ detailInfo.dryCompanyQuantity }}</span>
                </div>
              </div>
            </div>
            <div class="detail-item">
              <img class="train-umber" src="./images/02.png" alt="" />
              <div class="detail-info">
                <div class="info-item">
                  车辆数量:
                  <span class="value">{{
                    detailInfo.totalVehicleQuantity
                  }}</span>
                </div>
                <div class="info-item">
                  冷链车辆:
                  <span class="value">{{
                    detailInfo.refrigeratedVehicleQuantity
                  }}</span>
                </div>
                <div class="info-item">
                  干货车辆:
                  <span class="value">{{ detailInfo.dryVehicleQuantity }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--topRight-->
        <div
          class="chartPanel-child topRight"
          v-loading="topRightLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel_title"><span>·</span>城市配送车辆运营走势</div>
          <div
            class="chartPanel-child-chartArea"
            ref="topRightChartDOM"
            style="font-size: 1rem"
          ></div>
        </div>
        <!--centerMap-->
        <div
          class="chartPanel-child middleCenter"
          v-loading="mapLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel-child-chartArea" ref="page_center-map"></div>
        </div>
        <!--center-->
        <div
          class="chartPanel-child centerLeft"
          v-loading="centerLeftLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel_title">
            <span>·</span>广州市限行区域早晚高峰车辆运行情况
          </div>
          <div class="radio-box">
            <el-radio-group v-model="areaRadio" @input="switchRadio">
              <el-radio :label="100">A区</el-radio>
              <el-radio :label="101">B区</el-radio>
              <el-radio :label="145">C区</el-radio>
            </el-radio-group>
          </div>
          <div
            class="chartPanel-child-chartArea"
            ref="centerLeftChartDOM"
            style="font-size: 1rem"
          ></div>
        </div>
        <div
          class="chartPanel-child centerRight"
          v-loading="centerRightLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel_title">
            <span>·</span>城市干货配送车辆运行使用率
          </div>
          <div class="centerRight-content">
            <div
              class="chartPanel-child-box"
              ref="centerRightChartDOM1"
              style="font-size: 1rem"
            ></div>
            <div
              class="chartPanel-child-box"
              ref="centerRightChartDOM2"
              style="font-size: 1rem"
            ></div>
          </div>
        </div>
        <!--bottomLeft-->
        <div
          class="chartPanel-child bottomLeft"
          v-loading="bottomLeftLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel-child-box">
            <div class="chartPanel_title">
              <span>·</span> 重点限行区域运行情况
            </div>
            <img
              class="train-umber"
              src="@/assets/images/alarmBoard/trainNumber.png"
              alt=""
            />
            <img
              class="total-distance"
              src="@/assets/images/alarmBoard/totalDistance.png"
              alt=""
            />
            <div class="radio-box">
              <el-radio-group v-model="bottomLeftType" @input="switchType">
                <el-radio :label="1">冷链</el-radio>
                <el-radio :label="2">干货</el-radio>
              </el-radio-group>
            </div>
            <div
              class="bottom_child w100"
              ref="bottomLeftChartLeft"
              style="font-size: 1rem"
            ></div>
          </div>
        </div>
        <!--bottomRight-->
        <div
          class="chartPanel-child bottomRight"
          v-loading="bottomRightLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel_title">
            <span>·</span>城市冷链配送车辆运行使用率
          </div>
          <div class="bottomRight-content">
            <div
              class="chartPanel-child-box"
              ref="bottomRightChartDOM1"
              style="font-size: 1rem"
            ></div>
            <div
              class="chartPanel-child-box"
              ref="bottomRightChartDOM2"
              style="font-size: 1rem"
            ></div>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
// plugin
import moment from "moment";
import Echarts from "echarts";
import { mapGetters, mapMutations } from "vuex";
import {
  companyAndVehicleCount,
  getStorageTonnageOrderNew,
  getKeyRestrictAreaInfo,
  getBottomLeftData,
  vehicleUtilizationRate,
  fetchCenterLeftData
} from "@/api/board/allCar";
import {
  handleMapData,
  converVehicleData,
  handleCityData
} from "../home/chartConfig.js";

import {
  FetchCompanyInfoByCity,
  FetchNumberByAreaName
} from "@/api/home/gdHome.js";

// mixins
import resizeListener from "_private/mixins/resizeListener";

// charts setting
import echartsCarBoard from "./echartsCarBoard.js";

export default {
  mixins: [resizeListener],
  data() {
    return {
      curTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      timeInterval: null, // 时间显示定时器
      resizeTimer: null, // resize事件节流timer
      clientWidth: document.documentElement.clientWidth, // 页面宽度
      clientHeight: document.documentElement.clientHeight, // 页面高度
      reloadDataTime: 1000 * 60 * 60, // 刷新数据时间间隔
      areaRadio: 100,

      /************ topLeft ****************/
      topLeftLoading: false, // 左上角数据正在加载
      topLeftChartData: [],

      /*********** topRight ********************/
      topRightLoading: false, // 右上角数据正在加载
      topRightChartData: [],

      /*********** centerLeft ********************/
      centerLeftLoading: false, // 左下角数据正在加载
      centerLeftData: [],

      /*********** centerRight ********************/
      centerRightLoading: false, // 左下角数据正在加载
      centerRightData: [],

      /*********** bottomLeft ********************/
      bottomLeftLoading: false, // 左下角数据正在加载
      bottomRightLoading: false, // 下右角数据正在加载
      bottomLeftSwitchTimer: null, // 底部左侧类型切换定时器
      /*********** Right ********************/

      /************* centerMap ********************/
      fetchMapChartDataTimer: null,
      mapChartInstance: null, // 地图图表实例
      mapChartData: {
        freezerList: [],
        storageList: [],
        vehicleList: [],
        vehicleLat: []
      },
      bottomLeftType: 1,
      coldBottomLeftData: [],
      dryBottomLeftData: [],
      storageData: [],
      mapLoading: false,
      mapChartHighlightTimer: null,
      isGoDown: true, // 是否下钻地图
      detailInfo: {
        totalCompanyQuantity: "", // 冷藏车，干货车，企业总数
        totalVehicleQuantity: "", // 冷藏车，干货车，车辆总数
        refrigeratedCompanyQuantity: "", // 冷藏车企业数
        refrigeratedVehicleQuantity: "", // 冷藏车车辆数
        dryCompanyQuantity: "", // 干货车企业数
        dryVehicleQuantity: "" // 干货车车辆数
      }
    };
  },
  created() {
    !this.isFullScreen && this.updateFullScreen();
  },
  mounted() {
    this.$nextTick(() => {
      // 获取地图业务数据
      this.fetchTopLeftChartData();
      this.fetchTopRightData();
      this.setCLockTimeInterval();
      this.getCenterLeftData();
      this.getCenterRightData();
      this.getBottomRightData();
      this.fetchBottomLeftData();
      this.initMap();
      window.onresize = () => {
        this.resetEcharts();
      };
      // echartsCarBoard.resizeEcharts();
    });
  },

  beforeDestroy() {
    clearInterval(this.timeInterval); // 清除定时器
    clearInterval(this.mapChartHighlightTimer);
    clearInterval(this.bottomLeftSwitchTimer); // 清除底部左侧切换定时器
  },

  computed: {
    ...mapGetters(["isFullScreen", "userId"])
  },

  methods: {
    ...mapMutations(["updateFullScreen"]),
    handleRouterPush(router) {
      this.$router.push(router);
    },
    // 设置左上角钟表定时器
    setCLockTimeInterval() {
      clearInterval(this.timeInterval);
      // 设置定时器，每个1秒获取一次时间信息
      this.timeInterval = setInterval(() => {
        this.curTime = moment().format("YYYY-MM-DD HH:mm:ss");
      }, 1000);
    },
    // 重置echarts
    resetEcharts() {
      this.echartsMapObj && this.echartsMapObj.resize();
    },
    // 监控浏览器及元素变化
    resizeListener() {
      clearTimeout(this.resizeTimer);

      this.resizeTimer = setTimeout(() => {
        this.$nextTick(() => {
          this.clientWidth = document.documentElement.clientWidth;
          this.clientHeight = document.documentElement.clientHeight;
          this.mapChartInstance && this.mapChartInstance.resize();
        });
      }, 300);
    },
    // 渐变色
    setLinearColor(startColor, endColor) {
      return new Echarts.graphic.LinearGradient(
        0,
        0,
        0,
        1,
        [
          {
            offset: 0,
            color: startColor
          },
          {
            offset: 1,
            color: endColor
          }
        ],
        false
      );
    },
    // 渐变色
    setHLinearColor(startColor, endColor) {
      return new Echarts.graphic.LinearGradient(
        0,
        0,
        1,
        0,
        [
          {
            offset: 0,
            color: startColor
          },
          {
            offset: 1,
            color: endColor
          }
        ],
        false
      );
    },
    /*****************************中间部分地图数据*************************/
    // 初始化地圖
    async initMap() {
      // 获取地区内部/外部轮廓地理位置信息
      let geoDirName = this.$GLOBAL_CONFIG.home.map.geoDirName; // geo文件件
      let geoPromises = [
        import(`@/assets/geo/${geoDirName}/inline.json`),
        import(`@/assets/geo/${geoDirName}/outline.json`),
        import(`@/assets/geo/${geoDirName}/guangzhou/outline.json`)
      ];
      let [inlineGeo, outlineGeo, guangdongOutlineGeo] = await Promise.all(
        geoPromises
      );

      // 初始化地图
      this.mapOutlineGeo = Object.freeze(outlineGeo);
      this.mapGuangdongOutlineGeo = Object.freeze(guangdongOutlineGeo);
      Echarts.registerMap("inlineMap", inlineGeo);
      Echarts.registerMap("outlineMap", outlineGeo);
      this.getMapData();
    },
    // 请求数据
    async getMapData() {
      try {
        this.mapLoading = true;
        // 默认加载广州市地图
        let areaName = "广州市";
        let code = 440100; // 广州市的行政区划代码
        let json = await import(`@/assets/geo/guangdong/couties/${code}.json`);
        // 注册广州市地图
        Echarts.registerMap(areaName + "inlineMap", json);
        this.mapOutlineGeo = Object.freeze(json);

        // 获取广州市的地图数据
        this.fetchCenterCompanyData(areaName, 4456704);
      } catch (err) {
        console.log(err);
      } finally {
        this.mapLoading = false;
      }
    },
    // 初始化地图echarts
    initMapEcharts(cityName = "", data = {}) {
      console.log(data);
      const mapChartData = data;
      const option = {
        legend: {
          data: ["干货车", "冷链车", "冷库", "企业"],
          orient: "horizontal",
          textStyle: {
            color: "#666"
          },
          top: "2%",
          left: 20
        },
        tooltip: {
          show: true
        },
        visualMap: {
          show: true,
          type: "piecewise",
          right: 10,
          bottom: 20,
          calculable: true,
          animation: true,
          seriesIndex: [4],
          hoverLink: false,
          // 数据颜色范围,值越大颜色越深
          pieces: [
            {
              min: 100,
              max: 10000,
              color: this.setLinearColor("#006FEC", "#3B45F4")
            },
            {
              min: 76,
              max: 100,
              color: this.setLinearColor("#2B84EF", "#5B63F6")
            },
            {
              min: 51,
              max: 75,
              color: this.setLinearColor("#549CF2", "#7A81F7")
            },
            {
              min: 26,
              max: 50,
              color: this.setLinearColor("#7CB3F6", "#999EF9")
            },
            {
              min: 0,
              max: 25,
              color: this.setLinearColor("#A4CAF9", "#B8BCFB")
            }
          ]
        },
        geo: {
          name: cityName + "inlineMap",
          type: "map",
          map: cityName + "inlineMap",
          roam: true,
          zoom: 1,
          top: "5%",
          bottom: "5%",
          left: "5%",
          right: "13%",
          tooltip: {
            show: false
          },
          label: {
            normal: {
              show: true,
              position: "inside", //显示位置
              offset: [0, 0], //偏移设置
              color: "#fff",
              textShadowColor: "rgba(0,0,0,0.3)",
              textShadowBlur: 2,
              textShadowOffsetX: 0,
              textShadowOffsetY: 4,
              fontWeight: "lighter",
              fontSize: 12
            },
            emphasis: {
              color: "#fff"
            }
          },
          itemStyle: {
            normal: {
              borderColor: "#fff",
              borderWidth: 1
            },
            emphasis: {
              areaColor: "#3648F3"
            }
          },
          regions: [
            {
              name: "东沙群岛",
              itemStyle: {
                areaColor: "#A8C8FA"
              },
              label: {
                color: "#333"
              }
            }
          ]
        },
        series: [
          {
            name: "企业",
            type: "scatter",
            coordinateSystem: "geo",
            itemStyle: {
              color: "#f4f000" //波纹圈颜色
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let str = "";
                str = `
                <div style="padding:5px 10px">
                  <div style="font-size:14px;margin:0px">企业:</div>
                  <div style="font-size:14px;margin:0px"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:#f4f000;margin-right:5px;"></span>${params.name}</div>
                <div>
                `;
                return str;
              }
              //css样式，用于换行。
            },
            data: mapChartData.companyList
          },
          {
            name: "冷库",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#01af3c"
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let str = "";
                str = `
                <div style="padding:5px 10px">
                  <div style="font-size:14px;margin:0px">冷库:</div>
                  <div style="font-size:14px;margin:0px"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:#01af3c;margin-right:5px;"></span>${params.name}</div>
                <div>
                `;
                return str;
              }
            },
            data: mapChartData.storageList
          },
          {
            name: "冷链车",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#00b7f4"
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let str = "";
                str = `
                <div style="padding:5px 10px">
                  <div style="font-size:14px;margin:0px">冷链车:</div>
                  <div style="font-size:14px;margin:0px"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:#00b7f4;margin-right:5px;"></span>${params.name}</div>
                <div>
                `;
                return str;
              }
            },
            data: mapChartData.vehicleLat
          },
          {
            name: "干货车",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#ff9600"
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let str = "";
                str = `
                <div style="padding:5px 10px">
                  <div style="font-size:14px;margin:0px">干货车:</div>
                  <div style="font-size:14px;margin:0px"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:#ff9600;margin-right:5px;"></span>${params.name}</div>
                <div>
                `;
                return str;
              }
            },
            data: mapChartData.dryVehicleLonLatList
          },
          {
            type: "map",
            map: cityName + "inlineMap",
            geoIndex: 0,
            roam: true,
            tooltip: {
              show: true,
              formatter: params => {
                if (!params.data) return "";
                let str = "";
                str = `
                <div style="padding:5px 10px">
                  <p style="font-size:18px;margin:0px">${params.name}</p>
                  <p>
                    <span style="display:block;margin:5px 0">
                      入住企业总数：${params.data.comparyNum || 0}
                    </span>
                    <span style="display:block;margin:5px 0">
                      冷库总数：${params.data.storageNum || 0}
                    </span>
                    <span style="display:block;margin:5px 0">
                      干货车总数：${params.data.dryVehicleQuantity || 0}
                    </span>
                    <span style="display:block;margin:5px 0">
                      冷链车总数：${params.data.refrigeratedVehicleQuantity ||
                        0}
                    </span>
                  </p>
                <div>
                `;
                return str;
              }
            },
            data: mapChartData.vehicleList,
            label: {
              emphasis: {
                show: false
              },
              normal: {
                show: false
              }
            }
          }
        ]
      };
      if (this.echartsMapObj) {
        this.echartsMapObj.clear();
      }

      this.echartsMapObj = Echarts.init(this.$refs["page_center-map"]);
      this.echartsMapObj.setOption(option);
      window.addEventListener("resize", () => {
        this.echartsMapObj.resize();
        this.echartsMapObj.clear();
        this.echartsMapObj.setOption(option);
      });
      this.echartsMapObj.on("georoam", params => {
        if (params.dy || params.dx) return; //如果是拖拽事件则退出
        let _option = this.echartsMapObj.getOption(); //获取最新的option配制
        this.echartsMapObj.clear(); //清空
        this.echartsMapObj.setOption(_option); //更新修改后的option配制
      });
    },
    // 获取地图下钻二级市，区，县数据
    async fetchCenterCompanyData(cityName = "", bin) {
      try {
        this.mapLoading = true;
        let that = this;
        let [res, vehicleData] = await Promise.all([
          FetchCompanyInfoByCity({ cityName }),
          FetchNumberByAreaName(this.$qs.stringify({ bin: bin, transType: 25 }))
        ]);
        if (res && vehicleData) {
          if (res.code === 1 && res.result) {
            that.mapChartData = {
              companyList: handleCityData(res.result.companyLonLatList || []),
              freezerList: handleMapData(res.result.freezerLonLatList || []),
              storageList: handleMapData(res.result.storageLonLatList || []),
              vehicleLat: this.filterVehicle(
                handleMapData(res.result.coldVehicleLonLatList || [])
              ),
              dryVehicleLonLatList: this.filterVehicle(
                handleMapData(res.result.dryVehicleLonLatList || [])
              ),
              vehicleList: converVehicleData(vehicleData.result || [], "count")
            };
            this.initMapEcharts(cityName, that.mapChartData);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.mapLoading = false;
      }
    },
    // 筛选当前的车辆列表，将不属于当前地图的点过滤掉
    filterVehicle(vehicleList) {
      // 地图轮廓多边形的点的数据;
      let arr = [];
      this.mapOutlineGeo.features.forEach(f => {
        let polygonPoints = "";
        if (this.mapOutlineGeo.cp) {
          polygonPoints = f.geometry.coordinates[0];
        } else {
          polygonPoints = f.geometry.coordinates[0][0];
        }

        let result = null;
        // 过滤掉不属于该地区的点
        result = vehicleList.filter(item => {
          if (this.isInPolygon(item.value, polygonPoints)) {
            return item;
          }
        });
        arr.push(...result);
      });
      return arr;
    },
    /**
     * 判断当前点是否再地图 geoJSON 的多边形范围之内
     * @param {array} checkPoint 要判断的经纬度
     * @param {array} polygonPoints geoJSON 中的多边形数据
     * @return {boolean} 返回是否再当前多边形范围之内
     */
    isInPolygon(checkPoint, polygonPoints) {
      let counter = 0;
      let i;
      let xinters;
      let p1, p2;
      let pointCount = polygonPoints.length;
      p1 = polygonPoints[0];

      for (i = 1; i <= pointCount; i++) {
        p2 = polygonPoints[i % pointCount];
        if (
          checkPoint[0] > Math.min(p1[0], p2[0]) &&
          checkPoint[0] <= Math.max(p1[0], p2[0])
        ) {
          if (checkPoint[1] <= Math.max(p1[1], p2[1])) {
            if (p1[0] != p2[0]) {
              xinters =
                ((checkPoint[0] - p1[0]) * (p2[1] - p1[1])) / (p2[0] - p1[0]) +
                p1[1];
              if (p1[1] == p2[1] || checkPoint[1] <= xinters) {
                counter++;
              }
            }
          }
        }
        p1 = p2;
      }
      if (counter % 2 == 0) {
        return false;
      } else {
        return true;
      }
    },

    // 返回上一层
    dropUp() {
      this.getMapData();
      this.isGoDown = true;
    },
    // 计算横向尺寸百分比
    calcXDirectionSizeByPercent(size) {
      // return size;
      // 目前此页面不需要自适应，则注释下计算字体
      return (size / 1920) * this.clientWidth;
    },

    // 计算纵向向尺寸百分比
    calcYDirectionSizeByPercent(size) {
      // return size;
      // 目前此页面不需要自适应，则注释下计算字体
      return (size / 1080) * this.clientHeight;
    },
    // 千分符处理
    handleData(data) {
      let regex = /\d{1,3}(?=((\d{3})+$))/g;
      if ((data + "").indexOf(".") > -1) {
        regex = /\d{1,3}(?=((\d{3})+\.))/g;
      }
      let str = (data + "").replace(regex, "$&,");
      // let str = data.toLocaleString();
      return str;
    },
    /************************** topLeft ************************************/
    // 城市配送企业车辆情况
    async fetchTopLeftChartData() {
      try {
        this.topLeftLoading = true;
        const res = await companyAndVehicleCount();
        if (res.code === 1) {
          this.detailInfo = res.result;
        }
      } finally {
        this.topLeftLoading = false;
      }
    },

    /************************** topRight ************************************/
    // 城市冷链配送车辆每周运营走势
    async fetchTopRightData() {
      try {
        this.topRightLoading = true;
        const res = await fetchCenterLeftData({
          day: 7,
          userId: this.userId,
          dry: true
        });
        if (res.code === 1) {
          this.initTopRightChart(res.result);
        }
      } finally {
        this.topRightLoading = false;
      }
    },
    // 初始化右上角图表
    initTopRightChart(data) {
      const dataX = [],
        barData = [],
        dryBarData = [],
        lineData = [],
        dryLineData = [];
      data.forEach(item => {
        dataX.push(item.key);
        barData.push(item.runningKilometers);
        dryBarData.push(item.dryRunningKilometersDry);
        lineData.push(item.runningTime);
        dryLineData.push(item.dryRunningTimeDry);
      });
      echartsCarBoard.drawPillarLineChart(this.$refs.topRightChartDOM, {
        dataX,
        barData,
        lineData,
        dryBarData,
        dryLineData,
        colorConfig: {
          barColor: ["#32CD32", "#90EE90", "#26a126", "#2F4F4F"],
          lineColor: [
            "#32CD32",
            "rgba(34,139,34,.3)",
            "rgba(144, 238, 144, 0)"
          ],
          barDryColor: ["#FFDAB9", "#f8bc63", "#FF8C00", "#dd6839"],
          lineDryColor: [
            "#FFB72F",
            "rgba(237,75,105,.3)",
            "rgba(174, 112, 79, 0)"
          ]
        }
      });
    },

    /************************** centerMap ************************************/

    /************************** centerLeft ************************************/
    // 广州市限行区域晚高峰冷藏车运行情况（A,B,C）
    async getCenterLeftData() {
      try {
        this.centerLeftLoading = true;
        const res = await getStorageTonnageOrderNew();
        if (res.code === 1) {
          this.storageData = res.result;
          const dataX = [],
            morningData = [],
            eveningData = [];
          res.result.forEach(item => {
            if (item.areaId === 100) {
              if (item.amOrPm === 1) {
                dataX.push("早高峰7-9时");
                morningData.push(item.coldVehicle);
                eveningData.push(item.allVehicle);
              } else {
                dataX.push("晚高峰17-19时");
                morningData.push(item.coldVehicle);
                eveningData.push(item.allVehicle);
              }
            }
          });
          echartsCarBoard.drawPillarChart(this.$refs.centerLeftChartDOM, {
            dataX,
            morningData,
            eveningData
          });
        }
      } finally {
        this.centerLeftLoading = false;
      }
    },
    switchRadio(index) {
      let areaId = index;
      const dataX = [],
        morningData = [],
        eveningData = [];
      this.storageData.forEach(item => {
        if (item.areaId === areaId) {
          if (item.amOrPm === 1) {
            dataX.push("早高峰7-9时");
            morningData.push(item.coldVehicle);
            eveningData.push(item.allVehicle);
          } else {
            dataX.push("晚高峰17-19时");
            morningData.push(item.coldVehicle);
            eveningData.push(item.allVehicle);
          }
        }
      });
      echartsCarBoard.drawPillarChart(this.$refs.centerLeftChartDOM, {
        dataX,
        morningData,
        eveningData
      });
    },
    // 城市冷链配送车辆使用率及限行区域行驶数据
    async getCenterRightData() {
      try {
        this.centerRightLoading = true;
        const res = await getBottomLeftData({ userId: this.userId, dry: true });
        if (res.code === 1) {
          this.initCenterRightEcharts(res.result);
        }
      } finally {
        this.centerRightLoading = false;
      }
    },
    // 城市冷链配送车辆使用率及限行区域行驶数据
    async getBottomRightData() {
      try {
        this.bottomRightLoading = true;
        const res = await vehicleUtilizationRate({
          userId: this.userId
        });
        if (res.code === 1) {
          this.initBottomRightEcharts(res.result);
        }
      } finally {
        this.bottomRightLoading = false;
      }
    },
    // 中间右侧的图
    initCenterRightEcharts(data = []) {
      echartsCarBoard.drawDashBoardChart(this.$refs.centerRightChartDOM1, {
        rateValue: data.vehicleRate,
        title: "昨日使用率",
        unit: "%",
        color: ["#FFA07A", "#FF8C00", "#CD5C5C"]
      });
      const dataX = [],
        dataValue = [];

      data.coldTransportResults.forEach(item => {
        dataX.push(item.key);
        dataValue.push(item.vehicleRate);
      });
      echartsCarBoard.drawRakingChart(this.$refs.centerRightChartDOM2, {
        dataX,
        dataValue,
        inverse: true,
        colorList: ["#FFA07A", "#FF8C00", "#CD5C5C"],
        title: {
          text: "近7天城市配送车辆使用率",
          top: "18%",
          right: "5%",
          textStyle: {
            fontSize: 12
          }
        }
      });
    },
    initBottomRightEcharts(data = []) {
      echartsCarBoard.drawDashBoardChart(this.$refs.bottomRightChartDOM1, {
        rateValue: data.vehicleRate,
        title: "昨日使用率",
        unit: "%",
        color: ["#32CD32", "#228B22", "#2F4F4F"]
      });
      const dataX = [],
        dataValue = [];

      data.coldTransportResults.forEach(item => {
        dataX.push(item.key);
        dataValue.push(item.vehicleRate);
      });
      echartsCarBoard.drawRakingChart(this.$refs.bottomRightChartDOM2, {
        dataX,
        dataValue,
        inverse: true,
        colorList: ["#32CD32", "#228B22", "#2F4F4F"],
        title: {
          text: "近7天城市配送车辆使用率",
          top: "18%",
          right: "5%",
          textStyle: {
            fontSize: 12
          }
        }
      });
    },

    /************************** bottomLeft ************************************/
    // 获取城市冷配车在限时限行区域内的运行率
    async fetchBottomLeftData() {
      try {
        this.bottomLeftLoading = true;
        const res = await getKeyRestrictAreaInfo({ dry: true });
        if (res.code === 1) {
          this.coldBottomLeftData = res.result.cold;
          this.dryBottomLeftData = res.result.dry;
          this.initBottomLeftChart();
          this.startBottomLeftSwitchTimer(); // 启动定时切换
        }
      } finally {
        this.bottomLeftLoading = false;
      }
    },
    // 启动底部左侧类型切换定时器
    startBottomLeftSwitchTimer() {
      // 清除已存在的定时器
      if (this.bottomLeftSwitchTimer) {
        clearInterval(this.bottomLeftSwitchTimer);
      }
      // 每10秒切换一次类型
      this.bottomLeftSwitchTimer = setInterval(() => {
        this.bottomLeftType = this.bottomLeftType === 1 ? 2 : 1;
        this.switchType();
      }, 10000);
    },
    switchType() {
      this.initBottomLeftChart();
      // 手动切换时重置定时器
      this.startBottomLeftSwitchTimer();
    },
    // 初始化底部左侧柱状图
    initBottomLeftChart() {
      let data =
        this.bottomLeftType == 1
          ? this.coldBottomLeftData
          : this.dryBottomLeftData;
      const labelData = [],
        leftData = [],
        rightData = [];
      // data.forEach(item => {
      //   labelData.push(item.areaName);
      //   leftData.push(item.vehicleNumb);
      //   rightData.push(item.odomByArea);
      // });
      for (let i = 0; i < data.length; i++) {
        labelData.push(data[i].areaName);
        leftData.push(data[i].vehicleNumb);
        rightData.push(data[i].odomByArea);
      }
      echartsCarBoard.drawContrastChart(this.$refs.bottomLeftChartLeft, {
        labelData,
        leftData,
        rightData
      });
    },

    /************************** bottomRight ************************************/
    // 计算渐变颜色
    calcGradualChangeColor(index, length, startColor, endColor) {
      const rColor =
        startColor[0] + ((endColor[0] - startColor[0]) / length) * index;
      const gColor =
        startColor[1] + ((endColor[1] - startColor[1]) / length) * index;
      const bColor =
        startColor[2] + ((endColor[2] - startColor[2]) / length) * index;

      return `rgb(${rColor}, ${gColor}, ${bColor})`;
    }
  }
};
</script>

<style lang="scss" scoped>
$layout-width: 1920px;
$layout-height: 1080px;

.monitor-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;

  /*标题*/
  .title-section {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    z-index: 2;
    box-sizing: border-box;
    width: 100%;
    height: 0.6rem;
    padding-top: 0.11rem;
    background-image: url("~@/assets/images/alarmBoard/bigScreenTitleBg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    .button-list {
      position: absolute;
      top: 0;
      right: 10px;
      z-index: 2;
      box-sizing: border-box;
      height: 0.3rem;
      line-height: 0.4rem;
      padding-top: 0.11rem;
    }
    p {
      margin: 0;
    }

    .titleInfo {
      color: #3f83ff;
      font-size: 0.14rem;
      word-spacing: 1em;
      margin-left: 0.18rem;
      margin-top: 0.12rem;
    }

    .titleText {
      width: 5.6rem;
      height: 0.3rem;
      margin: 0 auto;
      text-align: center;
      font-size: 0.22rem;
      color: #fff;
      font-weight: bolder;
    }
  }

  .main {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    p {
      margin: 0;
    }

    .chartPanel {
      &_title {
        display: flex;
        align-items: center;
        height: 0.35rem;
        line-height: 0.35rem;
      }
      &-child {
        position: absolute;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &.topLeft {
          left: (10px / $layout-width) * 100%;
          top: (80px / $layout-height) * 100%;
          width: (532px / $layout-width) * 100%;
          height: (320px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;
        }

        &.topRight {
          right: (10px / $layout-width) * 100%;
          top: (80px / $layout-height) * 100%;
          width: (532px / $layout-width) * 100%;
          height: (320px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;
        }

        &.middleCenter {
          left: 0;
          right: 0;
          top: (90px / $layout-height) * 100%;
          margin: 0 auto;
          width: (836px / $layout-width) * 100%;
          height: (960px / $layout-height) * 100%;
          background-color: #fff;
        }
        &.centerLeft {
          left: (10px / $layout-width) * 100%;
          bottom: (340px / $layout-height) * 100%;
          width: (532px / $layout-width) * 100%;
          height: (320px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;

          .radio-box {
            position: absolute;
            right: 0.4rem;
            top: 0.44rem;
            z-index: 100;
            /deep/ .el-radio__label {
              font-size: 0.12rem;
            }
          }
        }
        &.centerRight {
          right: (10px / $layout-width) * 100%;
          bottom: (340px / $layout-height) * 100%;
          width: (532px / $layout-width) * 100%;
          height: (320px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;

          .centerRight-content {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 100%;

            .chartPanel-child-box {
              width: 50%;
              height: 100%;
            }
          }
        }
        &.bottomLeft {
          left: (10px / $layout-width) * 100%;
          bottom: (20px / $layout-height) * 100%;
          width: (532px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;
          .radio-box {
            position: absolute;
            right: 0.2rem;
            top: 0.35rem;
            z-index: 100;
            /deep/ .el-radio__label {
              font-size: 0.12rem;
            }
            .el-radio {
              margin-right: 0.1rem;
            }
          }
          .train-umber {
            width: 0.65rem;
            position: absolute;
            top: 22%;
            left: 27%;
          }
        }
        .total-distance {
          width: 1.21rem;
          position: absolute;
          top: 22%;
          left: 60%;
        }
        &.bottomCenter {
          left: 26%;
          bottom: (20px / $layout-height) * 100%;
          width: (920px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;

          .small-title {
            position: absolute;
            left: 67%;
            top: 18%;
            display: inline-block;
            z-index: 100;
            color: #000;
            font-weight: bolder;
            font-size: 0.18rem;
          }
        }
        &.bottomRight {
          right: (10px / $layout-width) * 100%;
          bottom: (20px / $layout-height) * 100%;
          width: (532px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;

          .bottomRight-content {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 100%;

            .chartPanel-child-box {
              width: 50%;
              height: 100%;
            }
          }
        }

        .chartPanel-child-box {
          display: flex;
          justify-content: space-between;
          width: 100%;
          height: 100%;
          .detail-item {
            padding-top: 0.3rem;
            width: 50%;
            font-size: 0.2rem;
            line-height: 0.44rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .train-umber {
              width: 0.5rem;
              margin-bottom: 0.14rem;
            }
            .info-item {
              .value {
                color: #22a2f7;
              }
            }
          }
        }

        .chartPanel_title {
          position: absolute;
          height: 0.3rem;
          height: 0.25rem;
          top: 0;
          left: 0.15rem;
          color: #000;
          font-size: 0.18rem;
          font-weight: bolder;

          span {
            display: inline-block;
            color: #3f83ff;
            width: 0.14rem;
          }
        }

        &-slide {
          position: absolute;
          right: 0.25rem;
          display: flex;
          z-index: 10;
          font-size: 0.14rem;

          li {
            margin-left: 0.03rem;
            padding: 0.05rem 0.06rem;
            font-size: 0.12rem;
            color: #7b89dc;
            transition: all 0.3s;
            cursor: pointer;

            &:hover,
            &.active {
              color: red;
              background: #7b89dc;
              border-radius: 0.05rem;
            }
          }
        }
        span.chartPanel-child-slide {
          color: redfff;
        }

        &-chartArea {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
        }

        .w25 {
          width: 25%;
          height: 100%;
        }

        .w50 {
          width: 45%;
          height: 100%;
        }
        .w100 {
          width: 100%;
          height: 100%;
        }

        .run_time {
          position: relative;
          .item_title {
            position: absolute;
            width: 100%;
            top: 0;
            left: 0;
            font-size: 0.12rem;
            color: #acc7ee;
            top: 0.42rem;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
